<svg [class]="svgClasses" [attr.width]="size" [attr.height]="height ? height : size" [attr.viewBox]="viewbox" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ng-container *ngFor="let elem of finalIcon">
        <ng-container [ngSwitch]="elem.type">

            <ng-container *ngSwitchCase="'path'">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    [attr.stroke]="elem.stroke ? elem.stroke :'none'"
                    [attr.stroke-width]="elem.strokeWidth ? elem.strokeWidth :'none'"
                    [attr.stroke-linecap]="elem.strokeLinecap ? elem.strokeLinecap :'none'"
                    [attr.stroke-miterlimit]="elem.stroke-miterlimit ? elem.strokeMiterlimit: 'none'"
                    [attr.stroke-linejoin]="elem.strokeLinejoin ? elem.strokeLinejoin :'none'"
                    [attr.d]="elem.d"
                    [attr.fill-rule]="elem.fillRule ? elem.fillRule : 'evenodd'"
                    [attr.clip-rule]="elem.clipRule ? elem.clipRule : 'evenodd'"
                    [attr.fill]="elem.fill ? elem.fill : 'none'"
                    [attr.mask]="elem.mask" />
            </ng-container>

            <ng-container *ngSwitchCase="'ellipse'">
                <ellipse 
                    [attr.cx]="elem.cx"
                    [attr.cy]="elem.cy"
                    [attr.rx]="elem.rx"
                    [attr.ry]="elem.ry"
                    [attr.fill]="elem.fill"/>
            </ng-container>

            <ng-container *ngSwitchCase="'circle'">
                <circle 
                    [attr.cx]="elem.cx" 
                    [attr.cy]="elem.cy" 
                    [attr.r]="elem.r" 
                    [attr.transform]="elem.transform" 
                    [attr.stroke]="elem.stroke ? elem.stroke :'none'" 
                    [attr.fill]="elem.fill"
                    [attr.fill-opacity]="elem.fillOpacity ? elem.fillOpacity : 'none'"/>
            </ng-container>

            <ng-container  *ngSwitchCase="'rect'">
                <rect 
                    [attr.x]="elem.x" 
                    [attr.y]="elem.y" 
                    [attr.width]="elem.width" 
                    [attr.height]="elem.height" 
                    [attr.rx]="elem.rx" 
                    [attr.transform]="elem.transform" 
                    [attr.stroke]="elem.stroke ? elem.stroke :'none'"
                    [attr.stroke-width]="elem.strokeWidth ? elem.strokeWidth :'none'"/>
            </ng-container>

            <ng-container  *ngSwitchCase="'mask'">
                <mask [attr.id]="elem.id" [attr.fill]="elem.fill">
                    <ng-container *ngFor="let subItem of elem.subItems">
                        <ng-container [ngSwitch]="subItem.type">
                            <ng-container  *ngSwitchCase="'path'">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                [attr.stroke]="subItem.stroke ? subItem.stroke :'none'"
                                [attr.stroke-width]="subItem.strokeWidth ? subItem.strokeWidth :'none'"
                                [attr.stroke-linecap]="subItem.strokeLinecap ? subItem.strokeLinecap :'none'"
                                [attr.stroke-linejoin]="subItem.strokeLinejoin ? subItem.strokeLinejoin :'none'"
                                [attr.d]="subItem.d"
                                />
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </mask>
            </ng-container>

        </ng-container>
    </ng-container>
</svg>
